// @ts-nocheck
import React from 'react';

import ColumnAliasesReducer from './reducer';
import ColumnAliasesSagas from './sagas';
import ColumnAliases from './columnAliases';

export default [
    {
        path: '/settings/columnaliases',
        key: 'key',
        componentId: 'columnAliases',
        component: (props) => <ColumnAliases {...props} />,
        routes: [],
        importReducer: () => {
            return [ColumnAliasesReducer];
        },
        isEnabled: state => true,
        importSagas: () => {
            return [ColumnAliasesSagas];
        },
        title: 'Skulicity | Admin Settings',
        name: 'Admin Settings - Column Aliases',
        headerName: 'Admin Settings - Column Aliases'
    }
];
